import * as React from 'react';
import { Link } from 'react-router';

export interface ReactorBlurbWidgetProps {
  name: string;
}

export const ReactorBlurbWidget: React.FC<ReactorBlurbWidgetProps> = (props) => {
  return (
    <>
      <h2>{props.name} is built with Reactor</h2>
      <p>
        {props.name}, as a result of being a{' '}
        <Link to="https://github.com/journeyapps-labs/reactor">Reactor system</Link>, provides a best-in-class developer
        experience that supercharges developer workflows.
      </p>
    </>
  );
};
